import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import DropzoneComponent from "react-dropzone-component";

class CreateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            errors: {}
        };
    }

    create = e => {
        e.preventDefault();
        this.props
            .create(this.state.item)
            .then(response => {
                this.props.hideCreate();
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
    };

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    djsConfig = {
        autoProcessQueue: true,
        params: {
            type: "temp",
            fileName: ""
        },

        parallelUploads: 1,
        timeout: 3600,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("auth_token")
        },
        maxFiles: 1,
        maxfilesexceeded: function(file) {
            this.removeAllFiles();
            this.addFile(file);
        },
        error: (file, error) => {
            this.context.state.showCodeMessage(error.message, "error");
        },
        success: (file, response, data) => {
            if (file.status === "success") {
                let temp = this.state.item;

                temp["image"] = response.data.filename;

                let error = this.state.errors;
                error["image"] = null;

                this.setState({ item: temp, errors: error });
                this.context.state.showCodeMessage(
                    "File uploaded successfully .",
                    "success"
                );
            } else {
                this.context.state.showCodeMessage(
                    "Error while uploading file .",
                    "error"
                );
            }
        }
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Create record</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            <div className="form-group">
                                <label htmlFor="name">Image</label>
                                <DropzoneComponent
                                    config={{
                                        postUrl:
                                            this.context.state.uploadUrl +
                                            "/api/admin/upload"
                                    }}
                                    djsConfig={this.djsConfig}
                                />
                                {this.state.errors.image ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.image}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    placeholder="Enter name"
                                ></input>
                                {this.state.errors.name ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.name}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    onChange={this.onChange.bind(this)}
                                    className="form-control"
                                    placeholder="Description"
                                    name="description"
                                    rows="3"
                                ></textarea>
                                {this.state.errors.description ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.description}
                                    </div>
                                ) : null}
                            </div>
                            
                            <div className="form-group">
                                <label htmlFor="badge_type">Badge Type</label>
                                <select
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="badge_type"
                                    name="badge_type"
                                >
                                    <option>Select option</option>
                                    <option value="skills">Skills</option>
                                    <option value="performance">Performance</option>
                                    <option value="experience">Experience</option>
                                </select>
                                {this.state.errors.badge_type ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.badge_type}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="paid">Paid</label>
                                <select
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="paid"
                                    name="paid"
                                >
                                    <option>Select option</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select>
                                {this.state.errors.paid ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.paid}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="auto">Auto</label>
                                <select
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="auto"
                                    name="auto"
                                >
                                    <option>Select option</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select>
                                {this.state.errors.auto ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.auto}
                                    </div>
                                ) : null}
                            </div>
                            <button
                                type="button"
                                onClick={this.create}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideCreate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CreateModel.contextType = AppContext;
export default CreateModel;



// WEBPACK FOOTER //
// ./src/components/admin/badges/CreateModel.js